import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DocumentGroupService } from 'src/app/Service/DocumentGroup/DocumentGroup.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DocumentGroupList',
  templateUrl: './DocumentGroupList.component.html',
  styleUrls: ['./DocumentGroupList.component.scss']
})
export class DocumentGroupListComponent implements OnInit {

  Token:String=""
  Filter_title:string=""
  page:number=0;
  Procssing:boolean=false

  modalRef_Delete: any;

  constructor(
    private DocumentGroup_Service:DocumentGroupService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }


  DataList_DocumentGroup:Array<General_Interface>=[]
  Data_Seleted_Delete:General_Interface=Empty_General_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,28).subscribe(
      data=>{
        this.ReadData_DocumentGroup()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

    
  }

  ReadData_DocumentGroup(){
    this.Procssing=true
    this.DocumentGroup_Service.GetRecord(this.Token).subscribe(
      data=>{
        this.DataList_DocumentGroup=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Change_Filter_title(){
    this.page=0
  }

  Delete(item:General_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.DocumentGroup_Service.DeleteDocumentGroup(item.id,this.Token).subscribe(
      data=>{
        if(item.del==false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully")
        this.ReadData_DocumentGroup()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
